/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { ActiveDate, DetailArr, DoneDate, FareSvg, Journey, Passenger, RoundJourney, StRedRound, StRound } from "../../../components/common/svg/AllSvg";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import PaginationComponent from "../../../components/common/form/PaginationComponent";
import EmptyList from "../../common/form/EmptyList";
import Error from "../../common/form/Error";

const Tickets = () => {
    const { t } = useTranslation('common');
    const [select, setSelect] = useState<any>(0)
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const category: any[] = [t("passenger.map.book_ticket_sec.active_tickets"), t("passenger.map.book_ticket_sec.completed_tickets")]
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    let totalPages: number = Math.ceil(total / +size?.value);
    const loaderData: any[] = [1, 2, 3, 4, 5]
    const params = useParams();
    const navigate = useNavigate();

    const getTickets = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`${url.all_tickets}?ticket_type=${select === 0 ? "active" : "completed"}&page=${page}&size=${+size?.value}`);

            if (res && res.status === 200) {
                setData(res?.data?.results)
                setTotal(res?.data?.count)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            setIsError(true)
            console.error("error while fetching tickets", error);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        (!!select || select === 0) && getTickets();
    }, [select, page, size])

    useEffect(() => {
        setPage(1)
    }, [select])

    return (
        <div className="flex flex-col w-full">
            <div className="flex flex-col gap-[5px] w-full pb-[20px] px-[15px] md:p-[30px] xlx:p-[35px] border-b border-primary border-opacity-[0.2]">
                <h3 className="text-primaryText dark:text-white font-semibold">{t("profile.tabs.tickets")}</h3>
                <h6 className="text-blackDull dark:text-textBlackDull font-medium xsm:max-w-max max-w-[200px]">{t("profile.tickets_desc")}</h6>
            </div>

            <div className="flex items-center gap-[8px] w-full border-b border-primary border-opacity-[0.2] px-[15px] md:px-[30px] xlx:px-[35px] overflow-x-auto">
                {Array.isArray(category) && category?.map((item: any, index: number) => (
                    <button key={index} className={`${select === index ? "text-primaryText dark:text-white border-b-[2px] border-primary" : "text-blackDull dark:text-textBlackDull focus:text-primaryText hover:text-primaryText dark:focus:text-white dark:hover:text-white focus:underline hover:underline border-b-[2px] border-transparent"} text-sm font-medium py-[6px] px-[16px] whitespace-nowrap`} onClick={() => setSelect(index)}>{item}</button>
                ))}
            </div>
            <div className="w-full h-full flex flex-col gap-[20px] items-center justify-center py-[20px] px-[15px] md:p-[30px] xlx:px-[35px]">
                {loading ?
                    <div className="flex flex-col gap-[15px] w-full">
                        {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                            <div key={index} className="border border-gray-200 dark:border-gray-700 shadow rounded-[10px] py-[18px] px-[25px] w-full animate-pulse">
                                <div className="flex w-full msm:items-center msm:justify-between border-b border-gray-200 dark:border-gray-700 pb-[10px] msm:flex-row flex-col gap-[15px]">
                                    <div className="w-full msm:w-auto flex items-center justify-between msm:justify-start gap-[15px]">
                                        <div className="flex flex-col gap-[6px]">
                                            <div className="w-[120px] xs:w-[150px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                            <div className="w-[120px] xs:w-[150px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                        </div>

                                        <div className="w-[24px] h-[24px] bg-gray-200 rounded-full dark:bg-gray-700 flex msm:hidden"></div>
                                    </div>

                                    <div className="flex items-center msm:gap-[50px]">
                                        <div className="flex gap-[15px] flex-wrap">
                                            <div className="flex items-center gap-[10px]">
                                                <div className="w-[30px] h-[30px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                <div className="flex flex-col gap-[4px]">
                                                    <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                    <div className="w-[30px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-[10px]">
                                                <div className="w-[30px] h-[30px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                <div className="flex flex-col gap-[4px]">
                                                    <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                    <div className="w-[30px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-[10px]">
                                                <div className="w-[30px] h-[30px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                <div className="flex flex-col gap-[4px]">
                                                    <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                    <div className="w-[30px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="w-[24px] h-[24px] bg-gray-200 rounded-full dark:bg-gray-700 hidden msm:flex"></div>
                                    </div>
                                </div>

                                <div className="mt-[10px] flex items-center gap-[8px]">
                                    <div className="w-[120px] xs:w-[150px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    <div className="flex flex-col gap-[15px] w-full">
                        {isError ? <Error /> : <>
                            {data?.length > 0 ? <>
                                {Array.isArray(data) && data.map((item: any, index: number) => (
                                    <div className="bg-[#F6F9FC] dark:bg-[#373840] rounded-[10px] py-[18px] px-[25px] w-full" key={index}>
                                        <div className="flex w-full msm:items-center msm:justify-between border-b border-black dark:border-[#454545] border-opacity-[0.21] pb-[10px] msm:flex-row flex-col gap-[15px]">
                                            <div className="w-full msm:w-auto flex items-center justify-between msm:justify-start gap-[15px]">
                                                <div className="flex gap-[10px]">
                                                    <div className="flex flex-col items-center justify-center my-[1px]">
                                                        {select === 0 ? <StRound /> : <StRedRound />}
                                                        {select === 0 ? <div className="w-[3px] h-full bg-primary mt-[-1px]"></div> : <div className="w-[3px] h-full bg-danger dark:bg-darkDanger mt-[-1px]"></div>}
                                                        {select === 0 ? <StRound /> : <StRedRound />}
                                                    </div>

                                                    <div className="flex flex-col">
                                                        <h6 className="text-primaryText dark:text-white font-extrabold uppercase">{item?.journey?.from_station}</h6>
                                                        <h6 className="text-primaryText dark:text-white font-extrabold uppercase">{item?.journey?.to_station}</h6>
                                                    </div>
                                                </div>

                                                <button onClick={() => !!params?.lang ? navigate(`/${params?.lang}/ticket/${item?.ticket_no}`) : navigate(`/ticket/${item?.ticket_no}`)} className="min-w-[24px] h-[24px] flex msm:hidden items-center justify-center rounded-full hover:border-primary hover:border focus:border-primary focus:border">
                                                    <DetailArr />
                                                </button>
                                            </div>

                                            <div className="flex items-center msm:gap-[50px]">
                                                <div className="flex gap-[15px] flex-wrap">
                                                    <div className="flex items-center gap-[10px]">
                                                        <div className="bg-secGreen bg-opacity-[0.2] flex items-center justify-center min-w-[30px] h-[30px] rounded-full">
                                                            <Passenger />
                                                        </div>
                                                        <div className="flex flex-col">
                                                            <p className="text-blackDull dark:text-textBlackDull text-opacity-[0.7] font-semibold">{t("passenger.map.book_ticket_sec.passenger")}</p>
                                                            <h6 className="text-blackDull dark:text-textBlackDull font-bold">{item?.no_of_tickets}</h6>
                                                        </div>
                                                    </div>

                                                    <div className="flex items-center gap-[10px]">
                                                        <div className={`${item?.booking_type === "One Way" ? "bg-secBlue" : "bg-secPink"} bg-opacity-[0.2] flex items-center justify-center min-w-[30px] h-[30px] rounded-full`}>
                                                            {item?.booking_type === "One Way" ? <Journey /> : <RoundJourney />}
                                                        </div>
                                                        <div className="flex flex-col">
                                                            <p className="text-blackDull dark:text-textBlackDull text-opacity-[0.7] font-semibold">{t("passenger.map.book_ticket_sec.journey")}</p>
                                                            <h6 className="text-blackDull dark:text-textBlackDull font-bold">{item?.booking_type === "One Way" ? t("passenger.home.banner.trip_planner.one_way") : t("passenger.home.banner.trip_planner.round_trip")}</h6>
                                                        </div>
                                                    </div>

                                                    <div className="flex items-center gap-[10px]">
                                                        <div className="bg-secOrange bg-opacity-[0.2] flex items-center justify-center min-w-[30px] h-[30px] rounded-full">
                                                            <FareSvg />
                                                        </div>
                                                        <div className="flex flex-col">
                                                            <p className="text-blackDull dark:text-textBlackDull text-opacity-[0.7] font-semibold">{t("passenger.map.book_ticket_sec.fare")}</p>
                                                            <h6 className="text-blackDull dark:text-textBlackDull font-bold">₹ {item?.amount}</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <button onClick={() => !!params?.lang ? navigate(`/${params?.lang}/ticket/${item?.ticket_no}`) : navigate(`/ticket/${item?.ticket_no}`)} className="min-w-[24px] h-[24px] hidden msm:flex items-center justify-center rounded-full focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]">
                                                    <DetailArr />
                                                </button>
                                            </div>
                                        </div>

                                        <div className="mt-[10px] flex items-center gap-[8px]">
                                            {select === 0 ? <ActiveDate /> : <DoneDate />}
                                            <h6 className="text-blackDull dark:text-textBlackDull font-semibold pt-[2px] xlx:pt-[3px]">{!!item?.journey?.journey_date ? moment(item?.journey?.journey_date).format('DD MMM YYYY, hh:mm A') : "-"}</h6>
                                        </div>
                                    </div>
                                ))}

                                <div className="flex items-center justify-center w-full mt-[10px]">
                                    <PaginationComponent
                                        page={page}
                                        total={totalPages}
                                        setPage={setPage}
                                    />
                                </div>
                            </> :
                                <EmptyList />
                            }
                        </>}
                    </div>}
            </div>
        </div>
    );
};

export default Tickets;